// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("trix")
require("@rails/actiontext")
// require("channels")

var jQuery = require("jquery");
require("jquery-ui");

// import jQuery from "jquery";
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;



require("bootstrap");
require("chartkick");
require("chart.js");

// require("admin-lte/plugins/chart.js/Chart.min.css");
// require("admin-lte/plugins/chart.js/Chart.min.js");

// require("admin-lte/plugins/jqvmap/jquery.vmap.js");
//todo revise again;
// require("admin-lte/plugins/jqvmap/maps/continents/jquery.vmap.australia.js");

require("admin-lte/plugins/jquery-knob/jquery.knob.min.js");


require("admin-lte/plugins/moment/moment.min.js");
require("admin-lte/plugins/daterangepicker/daterangepicker.js");
require("admin-lte/plugins/tempusdominus-bootstrap-4/js/tempusdominus-bootstrap-4.js");
// require("admin-lte/plugins/summernote/summernote-bs4.css");
// require("admin-lte/plugins/summernote/summernote-bs4");
require("admin-lte/plugins/overlayScrollbars/js/jquery.overlayScrollbars.js");
require("admin-lte/plugins/bootstrap4-duallistbox/jquery.bootstrap-duallistbox.min.js")
// require("admin-lte/plugins/dropzone/min/dropzone.min.js")




// datatable
// require("admin-lte/plugins/datatables/jquery.dataTables.min.js")
// require("admin-lte/plugins/datatables-responsive/js/dataTables.responsive.min.js")
// require("admin-lte/plugins/datatables-responsive/js/responsive.bootstrap4.min.js")
// require("admin-lte/plugins/datatables-buttons/js/dataTables.buttons.min.js")
// require("datatables.net-select-bs4/js/select.bootstrap4.js")
// require("admin-lte/plugins/datatables-bs4/js/dataTables.bootstrap4.min.js")



// from cdn
// require("admin-lte/plugins/jszip/jszip.min.js")
// require("admin-lte/plugins/pdfmake/pdfmake.min.js")
// require("admin-lte/plugins/pdfmake/vfs_fonts.js")


require("admin-lte/plugins/datatables-buttons/js/buttons.flash.min.js")
require("admin-lte/plugins/datatables-buttons/js/buttons.html5.min.js")
require("admin-lte/plugins/datatables-buttons/js/buttons.print.min.js")
require("admin-lte/plugins/datatables-buttons/js/buttons.colVis.min.js")
require("admin-lte/plugins/datatables-buttons/js/buttons.bootstrap4.min.js")
require("admin-lte/plugins/datatables-select/js/select.bootstrap4.min.js")

// window.pdfMake = require("admin-lte/plugins/pdfmake/pdfmake.min.js")
// window.pdfFonts = require("admin-lte/plugins/pdfmake/vfs_fonts.js")




import "src/underscore.js"
import "src/jquery.mentionsInput.js"
import "src/mentions.js"

require("admin-lte");
global.toastr = require("toastr")


import '../stylesheets/application';
import "@fortawesome/fontawesome-free/js/all";
require("ionicons/css/ionicons.min.css");
// require("./demo.js");
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

require("./dashboard");
import 'src/sweet-alert-confirm';
import 'src/custom-utility.js';
require("@nathanvda/cocoon")
import 'src/college-invoice';
import 'src/client_home.js';
import 'src/dropzone_file_upload.js';
require('./social-share-button.js.erb')


// import "src/account_charts.js"
import "src/jquery.raty.js"
import "src/ratyrate.js"
require('@client-side-validations/client-side-validations')
require("easy-autocomplete")
